import { client } from './epic'

export const variation = (feature) => {
  return client && client.getTreatment(feature)
}

export const localVariation = (feature) => {
  const prevTreatment = window.localStorage.getItem(`${feature}-treatment`)

  if (prevTreatment) {
    return prevTreatment === 'true'
  } else {
    const treatment = Math.random() >= 0.5
    window.localStorage.setItem(`${feature}-treatment`, treatment)
    return treatment
  }
}
